export function fetch(id) { return { type: 'QAS/FETCH', id } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/qas.js